import { Button } from '@startuptools/ui/Button';
import { Stack } from '@startuptools/ui/Stack';
import { Input } from '@startuptools/ui/Input';
import { forwardRef, type ReactNode } from 'react';
import { Trans } from '@lingui/react';
import { type DisplayIdentity } from '../Identity';

export type OnChangeFn = (_event: unknown, identity: DisplayIdentity) => void;

export const SelectSingleIdentity = forwardRef<
  HTMLDivElement,
  {
    value: DisplayIdentity | null;
    onChange: OnChangeFn;
    btnTextEmpty?: ReactNode;
    btnText?: ReactNode;
    selectIdentity: () => void;
    placeholder?: string;
  }
>(function Comp(
  {
    value,
    // onChange,
    btnText = <Trans id="Change" />,
    btnTextEmpty = <Trans id="Choose" />,
    selectIdentity,
    placeholder,
  },
  ref,
) {
  return (
    <>
      <Stack direction="row" gap={2} alignItems="center">
        <Input
          fullWidth
          value={value?.name}
          ref={ref}
          placeholder={placeholder}
          readOnly
          endDecorator={
            <Button onClick={() => selectIdentity()} variant={value ? 'outlined' : 'solid'}>
              {value ? btnText : btnTextEmpty}
            </Button>
          }
        />
      </Stack>
    </>
  );
});
